module.exports = __webpack_public_path__ + "img/album18_05.9f4aa4a2.jpg";